import React from 'react';
import { Tooltip } from 'antd';
import { StatusBadge } from '../../common';

/**
 * InactiveBadge — 「集計対象外」バッジ（ユーザー一覧の名前列に添える）
 * ------------------------------------------------------------------
 * User.inactive が true のユーザーに表示する。値は一覧取得時の「現在の設定」。
 * 組織集計はシーズン開始日時点の設定（変更履歴）で復元されるため、
 * 過去シーズンの集計とは一致しない場合がある旨をツールチップで補足する。
 *
 * 使い方（ellipsisColumn の subline に渡すと、名前の下の行に表示される）:
 *   subline: (record) => (record.inactive ? <InactiveBadge /> : null)
 */
const InactiveBadge = () => (
  <Tooltip title="現在の設定です。過去シーズンの集計は、各シーズン開始日時点の設定に従います。">
    <StatusBadge tone="neutral" style={{ marginInlineEnd: 0 }}>
      集計対象外
    </StatusBadge>
  </Tooltip>
);

export default InactiveBadge;
